<mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>
<mat-card class="content-card">

  <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px">
    <div fxFlex="70">
      <h3>Create Card Batch {{ batch?.id }} details</h3>
    </div>
    <div fxFlex="30" class="text-right">

    </div>

  </div>

  <div><span (click)="returnBack()" style="cursor: pointer">◀️ Go back</span></div>

  <br />

  <ng-container *ngIf="batch">
    <div style="margin: 10px;">

      <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px">
        <div fxFlex="30">
          Date and Time: {{ batch.timestamp | date : "yyyy-MM-dd HH:mm" }}
        </div>
        <div fxFlex="30">
          <div>
            Number of cards: {{ batch.cards.length }}<br />
            <ng-container *ngIf="batch.cards.length > 10">📦💳</ng-container>
            <ng-container *ngIf="batch.cards.length <= 10"><ng-container *ngFor="let _ of [].constructor(batch.cards.length > 20 ? 20 : batch.cards.length)">💳</ng-container></ng-container>
          </div>
        </div>

        <div fxFlex="30">
          <div>
            <ng-container *ngIf="!batch.processing && !batch.complete">
              <div>Pending</div>
              <div>
                <button mat-raised-button color="blue" style="margin-right: 10px;" [disabled]="isLoading || isExecutingBatch" (click)="executeBatch()">⏩ Execute Batch</button>
              </div>
            </ng-container>
            <ng-container *ngIf="!batch.processing && !batch.complete && !batch.imported">
              <div>Pending</div>
            </ng-container>
            <ng-container *ngIf="batch.processing">
              <div>Processing...</div>
              <mat-progress-bar mode="indeterminate"></mat-progress-bar>
            </ng-container>
            <ng-container *ngIf="batch.complete">
              <div>Processed</div>
              <div *ngIf="batch.imported">and Imported</div>
              <div>
                <button mat-raised-button color="blue" *ngIf="!batch.imported" style="margin-right: 10px;" [disabled]="batch.imported || isLoading || isExecutingBatch" (click)="importSuccessCards()">🔄 Import success cards</button>
              </div>

            </ng-container>
          </div>
        </div>


      </div>

  <div>

  </div>

    </div>


    <app-mat-table-generator #table
                             [saveFilters]=true
                             tableName="trustPayTransactionTable"
                             [useEmbededFilter]="true"
                             [columns]="columns"
                             [dataSource]="batch.cards"
                             [editEnabled]="false"
                             [deleteEnabled]="false"
                             [multiselectEnabled]="false"

    >
    </app-mat-table-generator>



  <div *ngFor="let card of batch.cards">

    <div fxLayout="row" style="margin-top: 15px; margin-bottom: 10px; ">
      <div fxFlex="50">
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>

              <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px" style="width: 100%">
                <div fxFlex="10">
                  <ng-container *ngIf="card.status === 'SUCCESS'">
                    🟢
                  </ng-container>
                  <ng-container *ngIf="card.status === 'FAILED'">
                    🔴
                  </ng-container>
                </div>
                <div fxFlex="30">
                  {{ card.firstName }} {{ card.lastName }}
                </div>

                <div fxFlex="auto">
                  {{card.cardToken}} ({{card.createType == 1 ? 'Virtual' : card.createType == 2 ? 'Physical' : card.createType}})
                  <ng-container *ngIf="card.error">
                    <span style="background-color: red; border-radius: 2px; padding: 2px; margin-left: 10px;">
                      {{card.error}}
                    </span>
                  </ng-container>
                </div>
              </div>

            </mat-panel-title>
          </mat-expansion-panel-header>
          <ng-container *ngIf="card.primaryToken"><div style="background-color: yellowgreen; border-radius: 5px; padding: 2px;">Secondary of {{ card.primaryToken }}</div></ng-container>
          <div class="list-item" fxLayout="row" *ngFor="let field of fields ">

            <app-content-row [field]="field" [entity]="card"></app-content-row>
          </div>

        </mat-expansion-panel>

      </div>
      <div fxFlex="50" class="text-right">

      </div>
    </div>

  </div>

</ng-container>

</mat-card>
